// extracted by mini-css-extract-plugin
export default {"btn":"file-statuses_btn__2lZKd","btnText":"file-statuses_btnText__uQGkU","select":"file-statuses_select__7pExe","lockIcon":"file-statuses_lockIcon__G2MKL"};